import React from "react";
import { Link } from "react-router-dom";
import { getImageUrl } from "../../../api/client";
import "./HotListPromo.css";

function PromoBlock({ block, className = "" }) {
  const tag = block?.tag || "";
  const title = block?.title || "";
  const subtitle = block?.subtitle || "";
  const link = block?.link || "/shop";
  const imageUrl = block?.imageUrl ? getImageUrl(block.imageUrl) : null;
  const backgroundColor = block?.backgroundColor || "#f5f0eb";
  const hasImage = Boolean(imageUrl);

  const style = {};
  if (imageUrl) {
    style.backgroundImage = `url(${imageUrl})`;
    style.backgroundSize = "cover";
    style.backgroundPosition = "center";
  } else {
    style.backgroundColor = backgroundColor;
  }

  const scrollToTop = () => window.scrollTo({ top: 0, behavior: "smooth" });

  return (
    <Link
      to={link}
      className={`hotListBlock ${className} ${hasImage ? "hotListBlockHasImage" : ""}`}
      style={style}
      onClick={scrollToTop}
    >
      <div className="hotListBlockContent">
        {tag && <span className="hotListTag">{tag}</span>}
        <h3 className="hotListTitle">{title}</h3>
        {subtitle && <p className="hotListSubtitle">{subtitle}</p>}
        <span className="hotListCta">SHOP NOW</span>
      </div>
    </Link>
  );
}

const DEFAULT_BLOCKS = {
  block1: { tag: "HOT LIST", title: "WOMEN COLLECTION", link: "/shop?gender=female" },
  block2: { tag: "HOT LIST", title: "MEN COLLECTION", link: "/shop?gender=male" },
  block3: { tag: "NEW ARRIVALS", title: "LATEST COLLECTION", link: "/shop" },
  block4: {
    title: "GIFT A RENTAL",
    subtitle: "Surprise someone special — call or WhatsApp us to arrange a rental gift.",
    link: "/contact",
    backgroundColor: "#f5d5c8",
  },
};

const HotListPromo = (props) => {
  const p = props?.props || {};
  const b1 = p.block1 || DEFAULT_BLOCKS.block1;
  const b2 = p.block2 || DEFAULT_BLOCKS.block2;
  const b3 = p.block3 || DEFAULT_BLOCKS.block3;
  const b4 = p.block4 || DEFAULT_BLOCKS.block4;

  return (
    <section className="hotListPromo">
      <div className="hotListPromoGrid">
        <div className="hotListPromoLeft">
          <PromoBlock block={b1} className="hotListPromoMain" />
        </div>
        <div className="hotListPromoRight">
          <PromoBlock block={b2} className="hotListPromoTop" />
          <div className="hotListPromoBottomRow">
            <PromoBlock block={b3} className="hotListPromoBottomLeft" />
            <PromoBlock block={b4} className="hotListPromoBottomRight" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default HotListPromo;
